import { css } from 'styled-components';

export const GradientText = css`
  background: linear-gradient(90deg, #FFA661, #F64B4D, #EB7BA3);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
